import React from 'react';
import { Link } from 'react-router-dom';
import logout from '../Components/Image/logout.png'
import Sidebar from '../Components/Sidebar';
import { Button, Table, Form, InputGroup, FormControl, Dropdown, ThemeProvider } from 'react-bootstrap';
import { connect } from 'react-redux'
import { getPODetails, GetPOAndPOLineItemSummary, postClaimPOByExpeditor, postUnClaimPOByExpeditor, getSearchedPO, GetExcellExportData,getProjectAllocationByUserId } from '../store/actions/poDetailsActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import AuthHandlerInstance from '../Classes/AuthHandler'
import SearchBar from '../Components/SearchBar';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from '@sweetalert/with-react'
import Pagination from 'react-bootstrap/Pagination'
import authInstance from '../Classes/AuthHandler';
import DropDown from '../Components/DropdownFlat';
import Loading from '../Components/Loader'
import { getAllSuppliers } from '../store/actions/vendorActions'
import { UpdateRemarksForPOLineId, postCustomerIcDate } from '../store/actions/expediting.Actions'
import { SetFlag, GetFilterList } from '../store/actions/masterActions'
import Select, { components } from "react-select"
import PaginationComponent from '../Components/PaginationComponent';
import toast from 'react-hot-toast';
// import { CSVLink } from "react-csv";

function formatedDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}
const Group = (props) => {
    const hasSelectedOption = props.children.some((opt) => opt.props.isSelected);

    const onClick = () => props.selectProps.onChange(props.options);
    return (
        <components.Group
            {...props}
            headingProps={{ ...props.headingProps, hasSelectedOption, onClick }}
        />
    );
};

const GroupHeading = ({ hasSelectedOption, ...props }) => {
    const selectedStyle = {
        backgroundColor: "#2684FF",
        color: "hsl(0,0%,100%)"
    };
    const style = { ...(hasSelectedOption && selectedStyle) };
    return <components.GroupHeading {...props} style={style} />;
};

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
}

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.dateformate = this.dateformate.bind(this);
        this.state = {
            userId: AuthHandlerInstance.getUserID(),
            employee: AuthHandlerInstance.getUserPayLoad(),
            roles: AuthHandlerInstance.getRoles(),
            modal: false,
            selectedItem: {},
            searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
            unClaimModal: false,
            tableData: [],
            currentPage: new URLSearchParams(this.props.location.search).get("currentPage") ? new URLSearchParams(this.props.location.search).get("currentPage") : 1,
            posPerpage: new URLSearchParams(this.props.location.search).get("posPerpage") ? new URLSearchParams(this.props.location.search).get("posPerpage") : 10,
            sortBy: new URLSearchParams(this.props.location.search).get("sortBy") ? new URLSearchParams(this.props.location.search).get("sortBy") : "all",
            sortByPo: new URLSearchParams(this.props.location.search).get("sortByPo") ? (new URLSearchParams(this.props.location.search).get("sortByPo")).split(',') : [],
            sortByLoc: "",
            poDocStartDate: new URLSearchParams(this.props.location.search).get("poDocStartDate") ? new URLSearchParams(this.props.location.search).get("poDocStartDate") : "",
            poDocEndDate: new URLSearchParams(this.props.location.search).get("poDocEndDate") ? new URLSearchParams(this.props.location.search).get("poDocEndDate") : "",
            latestDcStartDate: new URLSearchParams(this.props.location.search).get("latestDcStartDate") ? new URLSearchParams(this.props.location.search).get("latestDcStartDate") : "",
            latestDcEndDate: new URLSearchParams(this.props.location.search).get("latestDcEndDate") ? new URLSearchParams(this.props.location.search).get("latestDcEndDate") : "",
            statDeliveryStartDate: new URLSearchParams(this.props.location.search).get("statDeliveryStartDate") ? new URLSearchParams(this.props.location.search).get("statDeliveryStartDate") : "",
            statDeliveryEndDate: new URLSearchParams(this.props.location.search).get("statDeliveryEndDate") ? new URLSearchParams(this.props.location.search).get("statDeliveryEndDate") : "",
            drgApprovalStartDate: '',
            drgApprovalEndDate: '',
            sortByPODocDate: [],
            sortByWBS: new URLSearchParams(this.props.location.search).get("sortByWBS") ? (new URLSearchParams(this.props.location.search).get("sortByWBS")).split(',') : [],
            sortByStatus: "",
            sortByVendor: new URLSearchParams(this.props.location.search).get("sortByVendor") ? (new URLSearchParams(this.props.location.search).get("sortByVendor")).split(',') : [],
            checked: [],
            selectAll: false,
            dropdownarray: [{ value: "opened", status: "Opened" },
            { value: "all", status: "All" },
            { value: "claimed by me", status: "Claimed By Me" },
            { value: "claimed by others", status: "Claimed By Others" }
            ],
            finalvendorlist: [],
            editRemark: 0,
            finalpos: [],
            finalwbsno: [],
            finalstatus: [],
            finalpodate: [],
            finalloc: [],
            currentPage: 1,
            posPerpage: 10,
            totalPos: 0,
            loading: true,
            finalplantcode: [],
            finalemployees: [],
            sortByEmployees: new URLSearchParams(this.props.location.search).get("sortByEmployees") ? (new URLSearchParams(this.props.location.search).get("sortByEmployees")).split(',') : [],
            sortByPlantCode: new URLSearchParams(this.props.location.search).get("sortByPlantCode") ? (new URLSearchParams(this.props.location.search).get("sortByPlantCode")).split(',') : [],
            PODocDate: [],
            employees: [],
            WBSCode: [],
            PlantCode: [],
            VendorName: [],
            POSAPId: [],
            options: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
            ],
            docStatus: {
                1: { title: "is Approved", badge: "badge-success", status: "Approved" },
                2: { title: "is Rejected", badge: "badge-danger", status: "Rejected" },
                3: { title: "sent for Revision to Supplier", badge: "badge-primary", status: "Sent for Revision" },
                4: { title: "Awaiting approval", badge: "badge-dark", status: "Awaiting" },
                0: { title: "Submitted", badge: "badge-warning", status: "" },
                5: { title: "Partially Approved", badge: "badge-info", status: "" },
            },
            docStatus1: {
                1: { title: "is Forwarded", badge: "badge-success", status: "Approved" },
                2: { title: "is Rejected", badge: "badge-danger", status: "Rejected" },
                3: { title: "sent for Revision to Supplier", badge: "badge-primary", status: "Sent for Revision" },
                4: { title: "Awaiting approval", badge: "badge-dark", status: "Awaiting" },
                0: { title: "Submitted", badge: "badge-warning", status: "" },
                5: { title: "Partially Approved", badge: "badge-info", status: "" },
            },
            isShowFilter: false,
            isShowPoDocDate: false,
            isShowDCDate: false,
            isShowStatDeliverDate: false,
            CustomerIcDate: "",
            searchForOptions: [
                {
                    label: 'Currency', value: 'Currency'
                },
                {
                    label: 'Expeditor', value: 'Expeditor'
                },
                {
                    label: 'Location', value: 'Location'
                },
                {
                    label: 'Material', value: 'Material'
                },
                {
                    label: 'Payment term', value: 'Payment term'
                },
                {
                    label: 'Plant Code', value: 'Plant Code'
                },
                {
                    label: 'PO Number', value: 'PO Number'
                },
                {
                    label: 'Purchase Group', value: 'Purchase Group'
                },
                {
                    label: 'Vendor', value: 'Vendor'
                },
                {
                    label: 'WBS', value: 'WBS'
                },
            ],
            searchForItem: [],
            csvData:[],
            searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
        }
        this.unclaimPO = this.unclaimPO.bind(this);
        this.claimPO = this.claimPO.bind(this);
        this.handleDataLoading = this.handleDataLoading.bind(this);
        this.modal = this.modal.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSelect = this.handleSelect.bind(this);

    }

    filterData = async (currentPage = 1) => {
        await this.setState({ loading: true })
        let tableData = []
        let totalPos = 0
        let searchData = {
            currentPage: currentPage,
            posPerpage: this.state.posPerpage,
            searchTerm: this.state.searchTerm,
            poStatus: '1,2,3,5,6,7',
            userId: this.state.userId,
            sortByEmployees: this.state.sortByEmployees,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            sortByPo: this.state.sortByPo,
            sortByVendor: this.state.sortByVendor,
            sortBy: this.state.sortBy,
            poDocStartDate: this.state.poDocStartDate,
            poDocEndDate: this.state.poDocEndDate,
            latestDcStartDate: this.state.latestDcStartDate,
            latestDcEndDate: this.state.latestDcEndDate,
            drgApprovalStartDate: this.state.drgApprovalStartDate,
            drgApprovalEndDate: this.state.drgApprovalEndDate,
            statDeliveryStartDate: this.state.statDeliveryStartDate,
            statDeliveryEndDate: this.state.statDeliveryEndDate,
            searchFor: this.state.searchFor,
        }
        this.props.history.push({
            pathname: '/ExpiditingDashboard',
            search: "?" + new URLSearchParams(searchData).toString()
        })

        await this.props.GetPOAndPOLineItemSummary(searchData)
        if (this.props.poDetails && this.props.poDetails.poAndPoLineItemSearch && this.props.poDetails.poAndPoLineItemSearch.pos) {
            tableData = this.props.poDetails.poAndPoLineItemSearch.pos
            totalPos = this.props.poDetails.poAndPoLineItemSearch.pageinfo.totalcount
        }
        await this.setState({ tableData, totalPos, loading: false, currentPage: currentPage, editRemark: 0 })
    }

    componentDidMount = async () => {
        this.getFilterList()
        await this.handleDataLoading()
    }

    getFilterList = async () => {
        await this.props.GetFilterList()
        console.log(this.props.filterList, 'filterList')

        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        let finalemployees = []
        await finalemployees.push({ label: `Open`, value: 'opened' })
        await this.props.filterList[0].map(async (item) => {
            await finalemployees.push({ label: `${item.EmployeeName}`, value: item.EmployeeName })
        })
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })

        let POSAPId = []
        let WBSCode = []
        let PlantCode = []
        let VendorName = []
        let employees = []
        await this.state.sortByPlantCode.map(async (item) => {
            await PlantCode.push({ label: item, value: item })
        })
        await this.state.sortByWBS.map(async (item) => {
            await WBSCode.push({ label: item, value: item })
        })
        await this.state.sortByPo.map(async (item) => {
            await POSAPId.push({ label: item, value: item })
        })
        await this.state.sortByVendor.map(async (item) => {
            await VendorName.push({ label: item, value: item })
        })
        await this.state.sortByEmployees.map(async (item) => {
            await employees.push({ label: item, value: item })
        })
        console.log(employees, "[][][sss][][][]")

        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode, finalemployees, PlantCode, WBSCode, POSAPId, VendorName, employees })
    }

    handleDataLoading = async () => {
        let roles = AuthHandlerInstance.getRoles()
        let userId = AuthHandlerInstance.getUserID()
        let userName = AuthHandlerInstance.getUserPayLoad().fullName
        // await this.getFilterList()
        let search = new URLSearchParams(this.props.location.search).get("poStatus")
        // console.log(search, 'search')
        if (roles[7] == true && !search) {
            let sortByEmployees = []
            let sortBy = 'opened'
            let employees = []
            sortByEmployees.push(userName)
            employees.push({ label: `Open`, value: 'opened' })
            employees.push({
                label: userName,
                value: userName
            })
            console.log(employees, "[][][][][][]")
            await this.setState({ sortByEmployees, employees, sortBy, CustomerIcDate: "" })
        }
        if(roles[12]){
            let sortByWBS = []
            let WBSCode = []
            await this.props.getProjectAllocationByUserId({UserId:userId})
            let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
            if(ProjectCodes.length > 0){
              ProjectCodes.map((elem) => {
                sortByWBS.push(elem.ProjectCode)
                WBSCode.push({label:elem.ProjectCode, value: elem.ProjectCode})
              })
            }
            await this.setState({sortByWBS,WBSCode})
          }
        let sortBy = new URLSearchParams(this.props.location.search).get("sortBy")
        if (sortBy && sortBy == 'opened') {
            let employees = [...this.state.employees]
            employees.push({ label: `Open`, value: 'opened' })
            await this.setState({ employees })
        }
        
        await this.filterData(this.state.currentPage)
        // await this.props.GetExcellExportData()
        // let csvData = []
        // await this.props.poDetails.excelData[1].map(async (data) => {
        //     let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : ''
        //     await csvData.push({
        //         "Expeditor": data.ClaimbyExpeditorName ? data.ClaimbyExpeditorName : 'To Be Claimed',
        //         "PlantCode": data.PlantCode,
        //         "WBSCode": data.WBSCode,
        //         "VendorSapId": data.VendorSapId,
        //         "VendorName": data.VendorName,
        //         "POSAPId": data.POSAPId,
        //         "POLineItemSAPCode": data.POLineItemSAPCode,
        //         "PO Doc. Date": data.POCreationDate ? dateFormater(data.POCreationDate) : " ",
        //         "PO Uploaded On": data.RequestedDate ? dateFormater(data.RequestedDate) : " ",
        //         "PO Approved On": data.PoApprovalDate ? dateFormater(data.PoApprovalDate) : " ",
        //         "PO Status": data.TrnStatusName,
        //         "Item Description": data.POLineItemDescription,
        //         "Qty": data.POLineItemQuantity,
        //         "Drg. Status": data.DrawingStatus ? data.CountAssignment !== 0 ? "Document " + data.DocumentName + " " + this.state.docStatus1[data.DrawingStatus].title + " by " + data.approvedByName
        //                         : "Document " + data.DocumentName + " " + this.state.docStatus[data.DrawingStatus].title + " by " + data.approvedByName : " ",
        //         "Drg. Approved Date": data.DrawingActionDate ? dateFormater(data.DrawingActionDate) : " ",
        //         "Statistical Delivery Date": data.StatDeliveryDate ? dateFormater(data.StatDeliveryDate) : " ",
        //         "IC Offered": data.OfferedQuantity ? data.OfferedQuantity : 0,
        //         "IC Cleared": data.AcceptedQuantity ? data.AcceptedQuantity : 0,
        //         "IC Clear Date": data.InspectionRequestedDate ? dateFormater(data.InspectionRequestedDate) : " ",
        //         "Customer IC Date": data.CustomerICDate ? formatedDate(data.CustomerICDate) : null,
        //         "DC Qty": data.DispatchQuantity,
        //         "DC No": data.DCNo ? "DC-" + data.DCNo : "",
        //         "DC Clr. Date": data.DCIssuedDate ? dateFormater(data.DCIssuedDate) : "",
        //         "Delivered Qty": data.POLineItemTotalDeliveredQuantity ? data.POLineItemTotalDeliveredQuantity : 0,
        //         "Balance Qty": data.POLineItemTotalDeliveredQuantity ? data.POLineItemTotalDeliveredQuantity : 0,
        //         "PO Delivery Date": data.PODeliveryDate ? dateFormater(data.PODeliveryDate) : " ",
        //         "Expected Delivery Date":'',
        //         "PI Date":'',
        //         "Payment Date":'',
        //         "Vendor Location": data.VendorCountry && data.VendorState ? `${data.VendorCountry} / ${data.VendorState}` : " ",
        //         "IncoTerms" : data.incoTerms ? data.incoTerms : " ",
        //         "Payment Term": data.PaymentTermCode ? data.PaymentTermCode : " ",
        //         "Currency": data.Currency ? data.Currency : " ",
        //         "Net Price": data.NetPrice ? numberWithCommas(parseInt(data.NetPrice).toFixed(2)) : 0,
        //         "Net Value": data.NetValue ? numberWithCommas(parseInt(data.NetValue).toFixed(2)) : 0,
        //         "Delivered Value(INR)":'',
        //         "Balance Value(INR)":'',
        //         "Del. Indicator": data.DeletionIndicator ? data.DeletionIndicator : "",
        //         "GRN No.":'',
        //         "GRN Date":'',
        //         "OTD":'',
        //         "Remarks":data.Remarks
        //     })
        // }) // to get the PO Data for download
        // await this.setState({ csvData })
    }

    // ? handle search input
    handleISearch = (e) => {

        let searchTerm = e.target.value

        this.setState({
            searchTerm
        })

        console.log(this.state.searchTerm)

    }


    handleSelect = async (e) => {
        console.log(e.target.value, "HHHH")
        await this.setState({ sortBy: e.target.value })
        await this.filterData()
    }
    handleSelectPO = async (e) => {
        let sortByPo = []
        let POSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
                POSAPId.push(item)
            })
        }
        await this.setState({ sortByPo, POSAPId })
        await this.filterData()
    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.filterData()
    }
    handleSelectLoc = async (e) => {
        let sortByLoc = []
        if (e.length > 0) {
            e.map((item) => {
                sortByLoc.push(item.value)
            })
        }
        await this.setState({ sortByLoc })
        // console.log(this.state.sortByLoc, "JJJJ")
    }

    handleSelectEmployees = async (e) => {
        let sortByEmployees = []
        let sortBy = 'all'
        let employees = []
        if (e.length > 0) {
            e.map((item) => {
                if (item.value !== 'opened') {
                    sortByEmployees.push(item.value)
                } else {
                    sortBy = 'opened'
                }
                employees.push(item)
            })
        }
        await this.setState({ sortByEmployees, employees, sortBy })
        await this.filterData()
    }

    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })
        await this.filterData()
    }

    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
            })
        }
        await this.setState({ sortByVendor, VendorName })
        await this.filterData()
    }
    handleSelectPODocDate = async (e) => {
        let date = new Date()
        let prevYear = date.getFullYear() - 1
        let curYear = date.getFullYear()
        let nextYear = date.getFullYear() + 1
        let prevYear1 = date.getFullYear() - 2
        let prevYear2 = date.getFullYear() - 3
        let prevYear3 = date.getFullYear() - 4

        let sortByPODocDate = []
        let PoDocDates = []
        let PODocDate = []
        if (e.length > 0) {
            if (e[e.length - 1].value == prevYear || e[e.length - 1].value == prevYear1 || e[e.length - 1].value == prevYear2 || e[e.length - 1].value == prevYear3 || e[e.length - 1].value == curYear || e[e.length - 1].value == nextYear) {
                await e.map(async (item) => {
                    await sortByPODocDate.push(item.value)
                    await PODocDate.push(item)
                })
                await this.state.options.map(async (ev) => {
                    if (!sortByPODocDate.includes(e[e.length - 1].value + "|" + ev)) {
                        await sortByPODocDate.push(e[e.length - 1].value + "|" + ev)
                    }
                    if (!PODocDate.find(elem => elem.value == (e[e.length - 1].value + "|" + ev))) {
                        await PODocDate.push({
                            label: ev,
                            value: e[e.length - 1].value + "|" + ev
                        })
                    }
                })
            } else {
                await e.map(async (item) => {
                    await sortByPODocDate.push(item.value)
                    await PODocDate.push(item)
                })
            }
        }
        await sortByPODocDate.map(async (item) => {
            if (item.includes('|')) {
                let elem = item.split('|')
                let month = elem[1]
                let year = elem[0]
                let days = new Date(year, month, 0).getDate()
                for (let index = 1; index <= days; index++) {
                    await PoDocDates.push(formatDate(new Date(year, month - 1, index)))
                }
            }
        })
        console.log(PoDocDates, 'getDays')

        await this.setState({ sortByPODocDate: PoDocDates, PODocDate })
        await this.filterData()
    }
    handleSelectStatus = async (e) => {
        let sortByStatus = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByStatus.push(item.value)
            })
        }
        await this.setState({ sortByStatus })
        // console.log(this.state.sortByStatus, "JJJJ")
    }
    // ? handle searching
    handleSearching = async () => {
        await this.filterData()

    }

    handleSelectPoPerPage = async (e) => {
        await this.setState({ posPerpage: e.value })
        await this.filterData()
    }

    modal = (poRowData) => {
        // this.setState({})
        // console.log(poRowData)
        this.setState({ selectedItem: poRowData })
        this.setState({ modal: !this.state.modal });

        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
            // this.setState({selectedItem:null})

        }
    }

    unClaimModal = (poRowData) => {
        // this.setState({})
        console.log(poRowData)
        this.setState({ selectedItem: poRowData })
        this.setState({ unClaimModal: !this.state.unClaimModal });

        if (this.state.unClaimModal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
            // this.setState({selectedItem:null})

        }
    }

    handleChange = async () => {

        // Logic for displaying todos
        let indexOfLastTodo = this.state.currentPage * this.state.posPerpage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.posPerpage;
        let filteredTodos = await this.state.tableData.filter((item) => {
            if (this.state.sortBy == 'claimed by me') {
                return item.ClaimbyIdExpiditor === this.state.employee.employeeId
            }
            else if (this.state.sortBy == 'opened') {
                return !item.ClaimbyIdExpiditor
            } else {
                return item
            }
        })
        let currentTodos = await filteredTodos.slice(indexOfFirstTodo, indexOfLastTodo);

        let selectAll = this.state.selectAll
        let checked = []
        if (!selectAll) {
            currentTodos.map((item) => {
                if (!item.ClaimbyIdExpiditor) {
                    checked.push(item.PurchaseOrderId)
                }
            })
        }
        console.log(checked, 'checked')
        await this.setState({
            checked: checked,
            selectAll: !this.state.selectAll
        })
    }

    handleSingleCheckboxChange = async (PurchaseOrderId) => {
        let checked = [... this.state.checked]
        if (checked.includes(PurchaseOrderId)) {
            checked = checked.filter((item) => item !== PurchaseOrderId)
        } else {
            await checked.push(PurchaseOrderId)
        }

        await this.setState({ checked })
    }

    // claim multipl Po
    claimMultiplePO = async () => {
        let checked = this.state.checked

        var permissions = AuthHandlerInstance.getPermissions();
        let permissionId = 3;
        if (Array.isArray(permissions) && permissions.indexOf(4) > -1) {
            permissionId = 4;
        }
        var user = {
            userId: this.state.userId,
            permissionId: permissionId
        };

        for (let i = 0; i < checked.length; i++) {
            await this.props.postClaimPOByExpeditor(checked[i], user).then(resp => {
                console.log("resp", this.props.poDetails)
                if (this.props.poDetails.postClaimStatusByExpeditor.status) {
                    swal("PO has been succesfully claimed!!", { button: true, icon: "success" })
                }
            }
            )
        }
        await this.handleDataLoading()

        await this.setState({ checked: [] })
    }

    // ? claim PO function
    claimPO = async (poRowData) => {

        this.setState({ modal: !this.state.modal });
        var permissions = AuthHandlerInstance.getPermissions();
        let permissionId = 3;
        if (Array.isArray(permissions) && permissions.indexOf(4) > -1) {
            permissionId = 4;
        }
        var user = {
            userId: this.state.userId,
            permissionId: permissionId
        };

        swal("Claiming Purchase Order...", { button: false, icon: "info" })
        await this.props.postClaimPOByExpeditor(poRowData.PurchaseOrderId, user).then(resp => {
            console.log("resp", this.props.poDetails)
            if (this.props.poDetails.postClaimStatusByExpeditor.status) {
                swal("PO has been succesfully claimed!!", { button: true, icon: "success" })
            }
        }
        )
        this.handleDataLoading()
        this.setState({ selectedItem: null });


        // window.location.reload()

    }


    // ? unclaim PO function
    unclaimPO = async (poRowData) => {


        console.log("roles 2", poRowData)

        console.log(this.state.selectedItem)
        this.setState({ unClaimModal: !this.state.unClaimModal });
        var user = {
            employeeId: poRowData.ClaimbyId,
            permissionId: 4
        }
        // alert("rowData ", poRowData.PurchaseOrderId, user)

        // ! to uncomment
        swal("Unlocking Purchase Order...", { button: false, icon: "info" })
        await this.props.postUnClaimPOByExpeditor(poRowData.PurchaseOrderId, user).then(resp => {
            console.log("resp", this.props.poDetails)
            if (this.props.poDetails.postUnClaimStatusByExpeditor.status) {
                swal("PO has been succesfully unlocked!!", { button: true, icon: "success" })
            }
        }
        ).then(res => {
            console.log(res)
        })

        this.handleDataLoading()
        this.setState({ selectedItem: null });

        // window.location.reload()

    }

    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }

    dateformate(dateVal) {
        let d = new Date(dateVal);
        return d.toDateString();
    }

    handleClick = async (event) => {
        let currentPage = Number(event.target.id)
        if (!event.target.id) {
            currentPage = event.target.offsetParent.id
        }
        await this.filterData(currentPage)
    }
    clearFilter = async () => {
        await this.setState({
            currentPage: 1,
            searchTerm: '',
            sortByEmployees: [],
            sortByPlantCode: [],
            sortByWBS: [],
            sortByPo: [],
            sortByVendor: [],
            employees: [],
            WBSCode: [],
            PlantCode: [],
            VendorName: [],
            POSAPId: [],
            poDocStartDate: '',
            poDocEndDate: '',
            latestDcStartDate: '',
            latestDcEndDate: '',
            statDeliveryStartDate: '',
            statDeliveryEndDate: '',
            drgApprovalStartDate: '',
            drgApprovalEndDate: '',
            searchFor: '',
            sortBy: 'all',
            searchForItem: [],
        })
        await this.filterData()
    }

    setFlag = async (item) => {
        console.log(item, "+++++++++++")
        let params = {
            PoId: item.PurchaseOrderId,
            PoLineId: item.PurchaseOrderLineId,
            Flag: !item.flag,
            UserId: this.state.userId,
        }
        await this.props.SetFlag(params).then(async () => {
            toast.success("flag has been set", { duration: 3000 })
            await this.filterData()
        })
    }
    handleRemarks = async (e, Index) => {
        if (e.target.value.length > 120) {
            swal("Word Limit Exceeded", { button: true, icon: "error" })
            return false
        }
        let tableData = [...this.state.tableData]
        tableData[Index].Remarks = e.target.value
        await this.setState({ tableData })
        // console.log(tableData[Index].Remarks,"||||||||||||||||")
    }
    saveRemarks = async (item) => {
        await this.props.UpdateRemarksForPOLineId({
            PoLineId: item.PurchaseOrderLineId,
            Remarks: item.Remarks
        }).then(async () => {
            toast.success("Remarks has been set", { duration: 3000 })
            await this.handleDataLoading()
        })
    }
    handlepoDocStartDate = async (e) => {
        await this.setState({ poDocStartDate: e.target.value })
        await this.filterData()
    }
    handlepoDocEndDate = async (e) => {
        await this.setState({ poDocEndDate: e.target.value })
        await this.filterData()
    }
    handlelatestDcStartDate = async (e) => {
        await this.setState({ latestDcStartDate: e.target.value })
        await this.filterData()
    }
    handlelatestDcEndDate = async (e) => {
        await this.setState({ latestDcEndDate: e.target.value })
        await this.filterData()
    }
    handlestatDeliveryStartDate = async (e) => {
        await this.setState({ statDeliveryStartDate: e.target.value })
        await this.filterData()
    }
    handlestatDeliveryEndDate = async (e) => {
        await this.setState({ statDeliveryEndDate: e.target.value })
        await this.filterData()
    }
    handledrgApprovalStartDate = async (e) => {
        await this.setState({ drgApprovalStartDate: e.target.value })
        await this.filterData()
    }
    handledrgApprovalEndDate = async (e) => {
        await this.setState({ drgApprovalEndDate: e.target.value })
        await this.filterData()
    }
    EditRemarks = async (item) => {
        await this.setState({
            editRemark: item.PurchaseOrderLineId
        })
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    togglePoDocDate = async () => {
        this.setState({ isShowPoDocDate: !this.state.isShowPoDocDate })
    }
    toggleDCDate = async () => {
        this.setState({ isShowDCDate: !this.state.isShowDCDate })
    }
    toggleStatDeliverDate = async () => {
        this.setState({ isShowStatDeliverDate: !this.state.isShowStatDeliverDate })
    }
    handleInputICDate = async (e, index) => {
        let tableData = [...this.state.tableData]
        tableData[index] = e.target.value
        await this.setState({ tableData, CustomerIcDate: e.target.value })
    }
    handleClickSaveICDate = async (item) => {
        console.log(item.PurchaseOrderLineId)
        await this.props.postCustomerIcDate(this.state.CustomerIcDate, item.PurchaseOrderLineId)
        await this.handleDataLoading().then(() => {
            toast.success(`Data Saved`, {
                duration: 1000
            });
        })
    }
    render() {

        // console.log(this.props.poDetails.poAndPoLineItemSearch.pos,"abc")
        console.log(this.state.tableData, "abc")
        // stating pagination
        const { currentPage, posPerpage } = this.state;
        var filteredTodos = []

        // Logic for displaying todos
        const indexOfLastTodo = currentPage * posPerpage;
        const indexOfFirstTodo = indexOfLastTodo - posPerpage;
        filteredTodos = this.state.tableData
        const currentTodos = filteredTodos;
        const date = new Date()
        const prevYear = date.getFullYear() - 1
        const prevYear1 = date.getFullYear() - 2
        const prevYear2 = date.getFullYear() - 3
        const prevYear3 = date.getFullYear() - 4
        const curYear = date.getFullYear()
        const nextYear = date.getFullYear() + 1


        const option1 = this.state.options.map(e => {
            return {
                label: e,
                value: prevYear + '|' + e
            }
        })
        const option2 = this.state.options.map(e => {
            return {
                label: e,
                value: curYear + '|' + e
            }
        })
        const option3 = this.state.options.map(e => {
            return {
                label: e,
                value: nextYear + '|' + e
            }
        })
        const option4 = this.state.options.map(e => {
            return {
                label: e,
                value: prevYear1 + '|' + e
            }
        })
        const option5 = this.state.options.map(e => {
            return {
                label: e,
                value: prevYear2 + '|' + e
            }
        })
        const option6 = this.state.options.map(e => {
            return {
                label: e,
                value: prevYear3 + '|' + e
            }
        })

        const groups = [
            {
                label: prevYear3,
                value: prevYear3
            },
            ...option6,
            {
                label: prevYear2,
                value: prevYear2
            },
            ...option5,
            {
                label: prevYear1,
                value: prevYear1
            },
            ...option4,
            {
                label: prevYear,
                value: prevYear
            },
            ...option1,
            {
                label: curYear,
                value: curYear
            },
            ...option2,
            {
                label: nextYear,
                value: nextYear
            },
            ...option3,
        ];

        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }

        var roles = authInstance.getRoles()

        var permissions = AuthHandlerInstance.getPermissions()
        var tableLineItemData = this.props.poDetails.poAndPoLineItemSearch.pos
        if (!tableLineItemData) {

            return (
                <Loading />
            )
        }
        else {
            return (

                <div className="Container-fluid p-4 pageheight">
                    {/* ---Modal for claim PO yes/No Start */}
                    <div className="row">
                        <Modal isOpen={this.state.modal} >
                            <div className={"modal-bg" + (this.state.modal === 'false' ? 'open' : '')}>
                                <div className="modalheads">
                                    <ModalHeader HeaderStyle="modal-header">
                                        <div className="modal-text"><h4 >PO Claim</h4></div>
                                        <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </ModalHeader>
                                </div>
                                <div>
                                    <ModalBody >
                                        <div className="row text-center pb-2">
                                            <FontAwesomeIcon icon={'user-lock'} className="pt-4 submission-check-cirle pb-4" size="10x" />
                                        </div>
                                        <div className="row pt-4 p-4 modal-text text-centre">
                                            Are you sure you want to claim this PO?
                                        </div>
                                    </ModalBody>
                                </div>
                                <div>
                                    <ModalFooter FooterStyle="modal-footer">
                                        <div>
                                            <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">No</button>
                                            <button className="btn2 btn-sms1 mt-2  float-right" onClick={() => this.claimPO(this.state.selectedItem)} type="submit">Yes</button>
                                        </div>
                                    </ModalFooter>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    {/* ------Modal for claim PO yes/No End */}

                    {/* ------Modal for claim PO yes/No Start */}
                    <div className="row">
                        <Modal isOpen={this.state.unClaimModal} >
                            <div className={"modal-bg" + (this.state.unClaimModal === 'false' ? 'open' : '')}>
                                <div className="modalheads">
                                    <ModalHeader HeaderStyle="modal-header">
                                        <div className="modal-text"><h4 >PO Claim</h4></div>
                                        <button type="button" className="close" aria-label="Close" onClick={this.unClaimModal} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </ModalHeader>
                                </div>
                                <div >
                                    <ModalBody >

                                        <div className="row text-center pb-2">
                                            <FontAwesomeIcon icon={'lock-open'} className="pt-4 submission-check-cirle pb-4" size="10x" />
                                        </div>

                                        <div className="row pt-4 p-4 modal-text text-centre">

                                            Are you sure you want to unlock this PO?

                                        </div>
                                    </ModalBody>
                                </div>
                                <div >
                                    <ModalFooter FooterStyle="modal-footer">
                                        <div>
                                            <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.unClaimModal} type="submit">No</button>
                                            <button className="btn2 btn-sms1 mt-2  float-right" onClick={() => this.unclaimPO(this.state.selectedItem)} type="submit">Yes</button>
                                        </div>
                                    </ModalFooter>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    {/* ------Modal for claim PO yes/No End */}

                    <div className="row justify-content-between">
                        <div className="col-md-4 header">
                            <b>Expediting Dashboard</b>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className='col-1 pt-2'>
                                    {/* <CSVLink className="btn2 btn-sms1 float-right mt-2 rounded-pill" data={this.state.csvData} filename={'Expediting.csv'}>export</CSVLink> */}
                                </div>
                                <div className="col pt-3">
                                    <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                                </div>
                            </div>
                        </div>

                    </div>
                    {this.state.isShowFilter ?
                        <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal border-color filter-data pr-2 pl-2">
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Expeditor" isMulti value={this.state.employees} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalemployees} onChange={(e) => this.handleSelectEmployees(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="WBS" isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                            </div>
                            <div className="col">
                                <InputGroup>
                                    <FormControl className='outline-primary' type="text" readOnly placeholder="PO Dt." />
                                    <InputGroup.Append>
                                        <Button className="custom-drop-arrow" onClick={() => this.togglePoDocDate()} variant="outline-secondary"><FontAwesomeIcon icon={"chevron-down"} size="xs" /></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                                {this.state.isShowPoDocDate ?
                                    <>
                                        <label>Start Date</label>
                                        <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocStartDate(e) }} placeholder="Start Date" value={this.state.poDocStartDate} />
                                        <label>End Date</label>
                                        <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocEndDate(e) }} id={`inspectionEndDate-datepicker`} name={`inspectionEndDate-datepicker`} placeholder="inspection End Date" value={this.state.poDocEndDate} />
                                    </>
                                    : null}
                            </div>
                            <div className="col">
                                <InputGroup>
                                    <FormControl className='outline-primary' type="text" readOnly placeholder="DC Dt." />
                                    <InputGroup.Append>
                                        <Button className="custom-drop-arrow" onClick={() => this.toggleDCDate()} variant="outline-secondary"><FontAwesomeIcon icon={"chevron-down"} size="xs" /></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                                {this.state.isShowDCDate ?
                                    <>
                                        <label>Start Date</label>
                                        <Form.Control className="width-90" type="date" onChange={(e) => { this.handlelatestDcStartDate(e) }} id={`inspectionStartDate-datepicker`} name={`inspectionStartDate-datepicker`} placeholder="inspection Start Date" value={this.state.latestDcStartDate} />
                                        <label>End Date</label>
                                        <Form.Control className="width-90" type="date" onChange={(e) => { this.handleLatestDcEndDate(e) }} id={`inspectionEndDate-datepicker`} name={`inspectionEndDate-datepicker`} placeholder="inspection End Date" value={this.state.latestDcEndDate} />
                                    </>
                                    : null}
                            </div>
                            <div className="col">
                                <InputGroup>
                                    <FormControl className='outline-primary' type="text" readOnly placeholder="Stat.Del.Dt." />
                                    <InputGroup.Append>
                                        <Button className="custom-drop-arrow" onClick={() => this.toggleStatDeliverDate()} variant="outline-secondary"><FontAwesomeIcon icon={"chevron-down"} size="xs" /></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                                {this.state.isShowStatDeliverDate ?
                                    <>
                                        <label>Start Date</label>
                                        <Form.Control className="width-90" type="date" onChange={(e) => { this.handlestatDeliveryStartDate(e) }} id={`inspectionStartDate-datepicker`} name={`inspectionStartDate-datepicker`} placeholder="inspection Start Date" value={this.state.statDeliveryStartDate} />
                                        <label>End Date</label>
                                        <Form.Control className="width-90" type="date" onChange={(e) => { this.handlestatDeliveryEndDate(e) }} id={`inspectionEndDate-datepicker`} name={`inspectionEndDate-datepicker`} placeholder="inspection End Date" value={this.state.statDeliveryEndDate} />
                                    </>
                                    : null}
                            </div>
                        </div>
                        : null}
                    <div className="row mt-2 sticky">
                        <div className="col-md-12 centre-alligned  wrap">
                            {this.state.loading ?
                                <Loading />
                                :
                                <Table className="table1 table-exp text-left ">
                                    <thead className=" sticky-inner" style={{ height: "3rem" }}>
                                        <tr>
                                            <th className="align-middle">Actions</th>
                                            <th className="align-middle">Flag</th>
                                            <th className="align-middle">Expeditor</th>
                                            <th className="align-middle">Plant</th>
                                            <th className="align-middle">WBS</th>
                                            <th className="align-middle">Vendor</th>
                                            <th className="align-middle">PO No.</th>
                                            <th className="align-middle">Line</th>
                                            <th className="align-middle">Service Line</th>
                                            <th className="align-middle">Service No.</th>
                                            <th className="align-middle" style={{ minWidth: "95px" }}>PO Doc. Dt.</th>
                                            <th className="align-middle" style={{ minWidth: "95px" }}>PO Uploaded.</th>
                                            <th className="align-middle" style={{ minWidth: "95px" }}>PO Approved.</th>
                                            <th className="align-middle">Item Desc.</th>
                                            <th className="align-middle">PO Qty</th>
                                            <th className="align-middle" style={{ minWidth: "176px" }}>Drg. Status</th>
                                            <th className="align-middle" style={{ minWidth: "95px" }}>Drg. App. Dt.</th>
                                            <th className="align-middle" style={{ minWidth: "95px" }}>Stat. Del. Dt.</th>
                                            <th className="align-middle">IC Offered</th>
                                            <th className="align-middle">IC Cleared</th>
                                            <th className="align-middle">IC Clr. date</th>
                                            {roles[12] ?
                                                <th className="align-middle">Customer IC date</th>
                                                : null}
                                            <th className="align-middle">DC QTY</th>
                                            <th className="align-middle">DC No.</th>
                                            <th className="align-middle">DC Clr. date</th>
                                            <th className="align-middle" style={{ whiteSpace: "break-spaces" }}>Delivered Qty.</th>
                                            <th className="align-middle" style={{ whiteSpace: "break-spaces" }}>Balance Qty.</th>
                                            <th className="align-middle">PO Del. Dt.</th>
                                            <th className="align-middle">Exp. Del. Dt.</th>
                                            <th className="align-middle">P.I. Date</th>
                                            <th className="align-middle">Payment Date</th>
                                            <th className="align-middle" style={{ whiteSpace: "break-spaces" }}>Vendor Loc</th>
                                            <th className="align-middle">IncoTerms</th>
                                            <th className="align-middle" style={{ whiteSpace: "break-spaces" }}>Pmt. Term</th>
                                            <th className="align-middle">Currency</th>
                                            <th className="align-middle">Net Price</th>
                                            <th className="align-middle">Net Value</th>
                                            <th className="align-middle">Delivered Value <br />(INR)</th>
                                            <th className="align-middle">Balance Value <br />(INR)</th>
                                            <th className="align-middle">Del. Ind.</th>
                                            <th className="align-middle">GRN No.</th>
                                            <th className="align-middle">GRN Date</th>
                                            <th className="align-middle">OTD</th>
                                            <th className="align-middle">Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.state.tableData.length > 0) ?
                                            currentTodos.map((item, Index) =>


                                                // tableData.map((item, index)=>(
                                                <tr key={Index}>
                                                    <td className="align-middle headeralign">
                                                        {item.TrnStatusID == 7 ?
                                                            <div className="row justify-content-center text-center mr-0">
                                                                <div className="col-4">
                                                                    <Link to={{ pathname: '/ExpeditingPOAcceptanceTrail', state: { poId: item.PurchaseOrderId, lineItemID: item.PurchaseOrderLineId, POSAPId: item.POSAPId, lineItemSAPId: item.POLineItemSAPCode, serviceLineItemSAPId: item.POServiceLineItemSAPCode } }} >
                                                                        <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="sm" />
                                                                    </Link>
                                                                </div>
                                                                <div className="col-4">
                                                                    {
                                                                        roles[7] && !item.DeletionIndicator && item.isHold !== 1 ?
                                                                            item.ClaimStatusExpiditor ? (item.ClaimbyIdExpiditor === this.state.employee.employeeId ? <FontAwesomeIcon icon={"user-lock"} title="PO claimed by me" color={"blue"} size="sm" onClick={roles[7] ? () => this.unClaimModal(item) : null} /> : <FontAwesomeIcon icon={"lock"} title={"PO Claimed by " + item.ClaimbyExpeditorName} size="sm" onClick={roles[34] ? () => this.unClaimModal(item) : null} />) :
                                                                                <FontAwesomeIcon icon={"lock-open"} color={"black"} title="Claim PO" size="sm" onClick={() => this.modal(item)} />
                                                                            : null
                                                                    }
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="row justify-content-md-center">
                                                                <div className="col-sm-4">
                                                                    <FontAwesomeIcon icon={"eye"} color={"grey"} title="View" size="sm" />
                                                                </div>
                                                                {!item.DeletionIndicator && item.isHold !== 1 ?
                                                                    <div className="col-sm-4">
                                                                        <FontAwesomeIcon icon={"lock-open"} color={"grey"} title="Claim PO" size="sm" />
                                                                    </div>
                                                                    : null}
                                                            </div>

                                                        }
                                                        <span className={item.isHold === 1 ? 'badge badge-warning' : item.ManufacturingClearence ? 'badge badge-success' : ''}>
                                                            {item.isHold == 1 ? 'Hold' : item.ManufacturingClearence == 1 ? 'Cleared' : ' '}
                                                        </span>
                                                    </td>
                                                    <td className="align-middle headeralign">
                                                        {!item.DeletionIndicator && item.isHold !== 1 ?
                                                            roles[7] ? item.ClaimStatusExpiditor && (item.ClaimbyIdExpiditor === this.state.employee.employeeId) ?
                                                                <FontAwesomeIcon icon={"flag"} color={item.flag ? "red" : "black"} title="Flag" size="lg" onClick={() => this.setFlag(item)} />
                                                                : null
                                                                : <FontAwesomeIcon icon={"flag"} color={item.flag ? "red" : "black"} title="Flag" size="lg" onClick={() => this.setFlag(item)} />
                                                            : null}
                                                    </td>
                                                    <td className="align-middle headeralign">{item.ClaimbyExpeditorName ? item.ClaimbyExpeditorName : "To Be Claimed"}</td>
                                                    <td className="align-middle text-center">{item.PlantCode ? item.PlantCode : " "}</td>
                                                    <td className="align-middle headeralign">{item.WBSCode ? item.WBSCode : " "}</td>
                                                    <td className="align-middle min-vw-220">{item.VendorName ? item.VendorName : " "}</td>
                                                    <td className="align-middle text-center">{item.POSAPId}</td>
                                                    <td className="align-middle text-center">{item.POLineItemSAPCode ? item.POLineItemSAPCode : " "}</td>
                                                    <td className="align-middle text-center">{item.POServiceLineItemSAPCode ? item.POServiceLineItemSAPCode : " "}</td>
                                                    <td className="align-middle text-center">{item.ServiceNo ? item.ServiceNo : " "}</td>
                                                    <td className="align-middle text-center">{item.POCreationDate ? dateFormater(item.POCreationDate) : " "}</td>
                                                    <td className="align-middle text-center">{item.RequestedDate ? dateFormater(item.RequestedDate) : " "}</td>
                                                    <td className="align-middle text-center">{item.PoApprovalDate ? dateFormater(item.PoApprovalDate) : " "}</td>
                                                    <td className="align-middle min-vw-200">{item.POLineItemDescription ? item.POLineItemDescription : " "}</td>
                                                    <td className="align-middle headeralign">{(item.POLineItemQuantity ? item.POLineItemQuantity : 0) + ` ${item.OrderUnit}`}</td>
                                                    {/* <td className="align-middle headeralign">{item.OrderUnit ? item.OrderUnit : "NA"}</td> */}
                                                    <td className="align-middle headeralign">
                                                        {item.DrawingStatus ?
                                                            item.CountAssignment !== 0 ?
                                                                "Document " + item.DocumentName + " " + this.state.docStatus1[item.DrawingStatus].title + " by " + item.approvedByName
                                                                : "Document " + item.DocumentName + " " + this.state.docStatus[item.DrawingStatus].title + " by " + item.approvedByName
                                                            : " "}
                                                    </td>
                                                    <td className="align-middle text-center">
                                                        {item.DrawingActionDate ? dateFormater(item.DrawingActionDate) : " "}
                                                    </td>
                                                    <td className="align-middle text-center">{item.StatDeliveryDate ? dateFormater(item.StatDeliveryDate) : " "}</td>
                                                    <td className="align-middle amount-text">{item.OfferedQuantity ? item.OfferedQuantity : 0}</td>
                                                    <td className="align-middle amount-text">{item.AcceptedQuantity ? item.AcceptedQuantity : 0}</td>
                                                    <td className="align-middle text-center">{item.InspectionRequestedDate ? dateFormater(item.InspectionRequestedDate) : " "}</td>
                                                    {roles[12] ?
                                                        <td className="align-middle headeralign">
                                                            <div className="form-group d-flex">
                                                                <input type="date" className="form-control" style={{ width: "160px", height: "28px" }} value={item.CustomerICDate ? formatedDate(item.CustomerICDate) : null} onChange={(e) => this.handleInputICDate(e, Index)} />
                                                                <FontAwesomeIcon className="float-right mt-1" icon="check-circle" color="green" size="lg" onClick={() => this.handleClickSaveICDate(item)} />
                                                            </div>
                                                        </td>
                                                        : null}
                                                    <td className="align-middle headeralign">{item.DispatchQuantity}</td>
                                                    <td className="align-middle headeralign">{item.DCNo ? "DC-" + item.DCNo : ""}</td>
                                                    <td className="align-middle headeralign">{item.DCIssuedDate ? dateFormater(item.DCIssuedDate) : ""}</td>
                                                    <td className="align-middle amount-text">{item.POLineItemTotalDeliveredQuantity ? item.POLineItemTotalDeliveredQuantity : 0}</td>
                                                    <td className="align-middle amount-text">{item.POLineItemTotalDeliveredQuantity ? item.POLineItemTotalDeliveredQuantity : 0}</td>
                                                    <td className="align-middle amount-text">{item.PODeliveryDate ? dateFormater(item.PODeliveryDate) : " "}</td>
                                                    <td className="align-middle headeralign"></td>
                                                    <td className="align-middle headeralign"></td>
                                                    <td className="align-middle headeralign"></td>
                                                    <td className="align-middle min-vw-125">{item.VendorCountry && item.VendorState ? `${item.VendorCountry} / ${item.VendorState}` : " "}</td>
                                                    <td className="align-middle min-vw-150">{item.incoTerms ? item.incoTerms : " "}</td>
                                                    <td className="align-middle headeralign">{item.PaymentTermCode ? item.PaymentTermCode : " "}</td>
                                                    <td className="align-middle text-center">{item.Currency ? item.Currency : " "}</td>
                                                    <td className="align-middle amount-text">{item.NetPrice ? numberWithCommas(parseInt(item.NetPrice).toFixed(2)) : 0}</td>
                                                    <td className="align-middle amount-text">{item.NetValue ? numberWithCommas(parseInt(item.NetValue).toFixed(2)) : 0}</td>
                                                    <td className="align-middle headeralign"></td>
                                                    <td className="align-middle headeralign"></td>
                                                    <td className="align-middle headeralign">{item.DeletionIndicator ? item.DeletionIndicator : ""}</td>
                                                    <td className="align-middle headeralign">{ item.GRNDocNo ? item.GRNDocNo : "" }</td>
                                                    <td className="align-middle headeralign">{ item.GRNDocDt ? dateFormater(item.GRNDocDt) : "" }</td>
                                                    <td className="align-middle headeralign"></td>
                                                    <td className="align-middle min-vw-600">
                                                        {item.ClaimStatusExpiditor && item.ClaimbyIdExpiditor === this.state.employee.employeeId ?
                                                            this.state.editRemark !== item.PurchaseOrderLineId ?
                                                                <>
                                                                    <div className="form-group d-flex mb-0">
                                                                        <FontAwesomeIcon className="mt-2 ml-2" icon={"edit"} color={"black"} size="lg" onClick={() => this.EditRemarks(item)} />
                                                                        {item.Remarks}
                                                                    </div>
                                                                </>
                                                                :
                                                                <>
                                                                    <div className="form-group d-flex mb-0">
                                                                        <input type="text" className="form-control" disabled={item.ClaimStatusExpiditor && item.ClaimbyIdExpiditor === this.state.employee.employeeId ? false : true} value={item.Remarks} onChange={(e) => this.handleRemarks(e, Index)} />
                                                                        <FontAwesomeIcon className="mt-2" icon={"check-circle"} color={"green"} size="lg" onClick={() => this.saveRemarks(item)} />
                                                                    </div>
                                                                </>
                                                            :
                                                            <>
                                                                {item.Remarks}

                                                            </>}
                                                    </td>
                                                    {/* <td className="align-middle">{item.TrnStatusID < 7 || (item.TrnStatusID == 7 && item.ExpeditingStatusId == 0) ? item.TrnStatusName : item.TrnStatusID == 7 && item.ExpeditingStatusId == 1 ? item.TrnStatusName + " & "  + item.ExpeditingStatusName : item.ExpeditingStatusName}</td> */}
                                                </tr>


                                            )
                                            : null}
                                    </tbody>
                                </Table>
                            }
                        </div>
                    </div>
                    <div className="float-right ">
                        <hr></hr>
                        {/* <Pagination size="sm" className=" pagination">{renderPageNumbers}</Pagination> */}
                        <PaginationComponent filteredTodos={filteredTodos} currentPage={currentPage} posPerpage={posPerpage} totalPos={this.state.totalPos} handleClick={this.handleClick} handleSelectPoPerPage={this.handleSelectPoPerPage} showPosPerpage={true} />
                        <hr></hr>
                    </div>
                </div>

            )
        }
    }
}



const mapStateToProps = (state) => ({ poDetails: state.poDetails, supplier: state.vendorReducer, filterList: state.masterReducer.filterList })
export default connect(mapStateToProps, { getPODetails, GetPOAndPOLineItemSummary, postClaimPOByExpeditor, postUnClaimPOByExpeditor, getSearchedPO, getAllSuppliers, SetFlag, UpdateRemarksForPOLineId, GetFilterList, postCustomerIcDate, GetExcellExportData, getProjectAllocationByUserId })(Dashboard)
